import React from 'react';
import { Typography, Grid, Link } from '@material-ui/core';
import config from '../../config/config.json';

export default function (props) {
    return (
        <>
            <Typography variant="h5" color="initial">
                <code>
                    Eventos
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Eventos del Centro de Meteorología, Santiago de Cuba
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/eventos</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/eventos`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/eventos
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve listado de eventos meteorológicos posteriores a la fecha actual, en caso de existir. Donde cada evento se representa por un objeto.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo: <br /> {/* Ejemplo de respuesta */}
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                [
                <div>{`{`}</div>
                <div><span className="pre-key">"titulo"</span>: <span className="pre-value">"Forum de Base",</span></div>
                <div><span className="pre-key">"lugar"</span>: <span className="pre-value">"CMP, Santiago de Cuba",</span></div>
                <div><span className="pre-key">"descripcion"</span>: <span className="pre-value">"El día 20 de junio se celebrará en nuestro Centro el Forum de Base. Todos los interesados por favor envien sus trabajos a mirna.martinez@scu.insmet.cu. Se aceptarán los trabajos hasta el 10 de junio. Por favor no tarde y sea uno de los participantes."</span>,</div>
                <div><span className="pre-key">"fecha_inicio"</span>: <span className="pre-value">"2021-06-20 08:00:00",</span></div>
                <div><span className="pre-key">"fecha_culminacion"</span>: <span className="pre-value">"2021-06-20 08:00:00"</span></div>
                <div>{`}`},</div>
]
            </pre>

            <Typography variant="h6" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>titulo</td>
                        <td>string</td>
                        <td>Representa el título del evento</td>
                    </tr>
                    <tr>
                        <td>lugar</td>
                        <td>string</td>
                        <td>Lugar donde se efectuará el evento</td>
                    </tr>
                    <tr>
                        <td>descripcion</td>
                        <td>string</td>
                        <td>Una breve descripcion del evento</td>
                    </tr>
                    <tr>
                        <td>fecha_inicio</td>
                        <td>date</td>
                        <td>Fecha de inicio del evento</td>
                    </tr>
                    <tr>
                        <td>fecha_culminacion</td>
                        <td>date</td>
                        <td>Fecha de culminación del evento</td>
                    </tr>
                </tbody>
            </table>
            <br />

            {/* Possible errors: <br />
            Error code, 	Description <br />
            401 Unauthorized 	The accessToken is invalid, lacks the listPublications scope or has been revoked. <br />
            403 Forbidden 	The request attempts to list publications for another user. <br /> */}
        </>
    )
}